var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-strip"},[_c('b-button',{attrs:{"type":"is-small is-active"}},[_vm._v("Contact Us")]),_c('b-button',{attrs:{"type":"is-small"}},[_vm._v("How to videos")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }